import React from "react";
import { Step1ScheduleReserveContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import queryString from "query-string";
import { withTranslation } from "react-i18next";
import { HeaderBackMusicHallWidget } from "widgets";
import { Buttons, Displays, Headers, Navigations } from "components";

class Step1ScheduleReserveContainer extends React.Component {
  handleGoBack = () => {
    const { rentalStep, router } = this.props;
    const { id } = router.params;
    this.props.router.navigate(
      rentalStep === 2
        ? `${ROUTE_PATH.MUSIC_HALL}/${id}/booking/1${router.location.search}`
        : `${ROUTE_PATH.MUSIC_HALL_AND_PRACTICE}/6913fddf8682dc3a88f16b7c`,
    );
  };

  handleNextStep = () => {
    const { rentalStep, router } = this.props;
    const { id } = router.params;
    this.props.router.navigate(
      rentalStep === 2
        ? `${ROUTE_PATH.MUSIC_HALL}/${id}/booking/condition/1${router.location.search}`
        : `${ROUTE_PATH.MUSIC_HALL}/${id}/booking/rental/2${router.location.search}`,
    );
  };

  render() {
    const { rentalStep, router, t } = this.props;
    const isPreview =
      queryString.parse(router.location.search)?.is_preview === "true";
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("Music Hall Bangkok", { ns: "common" }),
        path: `${ROUTE_PATH.MUSIC_HALL_AND_PRACTICE}/6913fddf8682dc3a88f16b7c`,
      },
    ];
    return (
      <Step1ScheduleReserveContainerStyled isPreview={isPreview}>
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="step1_schedule_reserve_container">
          {!isPreview ? (
            <div className="header_layout mb_0">
              <Headers.NewPageHeader
                title={"YAMAHA MUSIC  HALL, BANGKOK"}
                sub_title={"Rental Registration form "}
              />
            </div>
          ) : (
            <div className="header_backhome_layout">
              <HeaderBackMusicHallWidget room_booking_id={router.params.id} />
            </div>
          )}
          {isPreview && (
            <div className="title_preview">
              {t("Review Information", { ns: "common" })}
            </div>
          )}
          <div className="body_layout">
            <div className="detail_layout">
              <Displays.TitleReserve
                title_reserve={t("Rental Detail", { ns: "room" })}
              />
            </div>
            {rentalStep === 2 ? (
              <Displays.ImageSmooth
                src={"/assets/images/backgrounds/rent-musichall2.png"}
                alt="booking_steps_2"
                aspectRatio="1440 / 2560"
              />
            ) : (
              <Displays.ImageSmooth
                src={"/assets/images/backgrounds/rent-musichall.jpg"}
                alt="booking_steps"
                aspectRatio="822 / 1461"
              />
            )}
          </div>
          <div className="button_layout">
            <div className="button1">
              {(!isPreview || rentalStep === 2) && (
                <Buttons.BgStandard
                  theme_white_purple
                  label={t("Back", { ns: "common" })}
                  onClick={this.handleGoBack}
                />
              )}
            </div>
            <div className="button2">
              <Buttons.BgStandard
                theme_white_purple={isPreview}
                label={t("Next", { ns: "common" })}
                onClick={this.handleNextStep}
              />
            </div>
          </div>
        </div>
      </Step1ScheduleReserveContainerStyled>
    );
  }
}

export default withTranslation(["common", "room"])(
  withRouter(Step1ScheduleReserveContainer),
);
